const dtGenerator = require("./dt-generator");

let currentPage = 0;
let allDataLoaded = false;
let itemsPerPage = 50; // valor por defecto

/**
 * Organiza y muestra la primera página de datos en el DT
 * @param {Array} row - Datos sin organizar
 * @param {Object} htmlDt - Estructura del HTML del DataTable
 * @param {Function} organizeRow - Función que organiza los datos por entidad
 * @param {Number} itemsToShow - (Opcional) cantidad de filas por página
 */
export function organizeRowDtReport(row, htmlDt, organizeRow, itemsToShow = 50) {
  currentPage = 0;
  allDataLoaded = false;
  itemsPerPage = itemsToShow;

  const start = currentPage * itemsPerPage;
  const end = start + itemsPerPage;
  const pageData = row.slice(start, end);

  if (pageData.length === 0) {
    allDataLoaded = true;
    updateFooter(row.length, row.length, htmlDt);
    return;
  }

  const formattedData = organizeRow(pageData);
  dtGenerator.addBody(formattedData, htmlDt, false);
  currentPage++;

  const shown = currentPage * itemsPerPage;
  updateFooter(row.length, shown, htmlDt);
}

export function loadMoreRows(data, htmlDt, organizeRow) {
  if (allDataLoaded) return;

  const start = currentPage * itemsPerPage;
  const end = start + itemsPerPage;
  const pageData = data.slice(start, end);

  if (pageData.length === 0) {
    allDataLoaded = true;
    updateFooter(data.length, data.length, htmlDt);
    return;
  }

  const formattedData = organizeRow(pageData);
  dtGenerator.addBody(formattedData, htmlDt, false);
  currentPage++;
  updateFooter(data.length, currentPage * itemsPerPage, htmlDt);
}

export function sortBy(data, htmlDt, organizeRow) {
  allDataLoaded = false;
  currentPage = 1;

  const firstPageData = data.slice(0, itemsPerPage);
  const formattedData = organizeRow(firstPageData);

  htmlDt.dtBody.innerHTML = "";
  dtGenerator.addBody(formattedData, htmlDt, false);
  updateFooter(data.length, firstPageData.length, htmlDt);
}

export function searchValue(data, htmlDt, organizeRow) {
  allDataLoaded = false;
  currentPage = 1;

  const firstPageData = data.slice(0, itemsPerPage);
  const formattedData = organizeRow(firstPageData);

  htmlDt.dtBody.innerHTML = "";
  dtGenerator.addBody(formattedData, htmlDt, false);
  updateFooter(data.length, firstPageData.length, htmlDt);
}

function updateFooter(totalRows, shownRows, htmlDt) {
  let remaining = totalRows - shownRows;
  if (remaining <= 0) {
    remaining = 0;
    htmlDt.footer.classList.add("footer-disabled");
  } else {
    htmlDt.footer.classList.remove("footer-disabled");
  }

  const label = htmlDt.footer.querySelector("label");
  if (label) {
    label.textContent = `LOAD MORE ${remaining}`;
  }
}